var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStrike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.414 9.364H1.998C2.142 11.038 3.186 11.902 4.95 11.902C6.606 11.902 7.704 11.146 7.704 9.616C7.704 8.482 7.164 7.78 5.13 7.006C2.808 6.124 1.98 5.242 1.98 3.784C1.98 1.948 3.276 0.291999 6.084 0.291999C8.874 0.291999 10.062 1.894 10.08 3.766H8.514C8.37 2.488 7.758 1.588 5.958 1.588C4.392 1.588 3.6 2.506 3.6 3.604C3.6 4.468 3.996 5.008 5.868 5.728C8.46 6.682 9.36 7.78 9.36 9.4C9.36 11.362 8.1 13.18 4.788 13.18C1.89 13.18 0.468 11.596 0.414 9.364Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.528H10.314V8.428H0V7.528Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrike);
export default __webpack_public_path__ + "static/media/strike.e0bf1a46f6124f34a3aaa7600e014f99.svg";
export { ForwardRef as ReactComponent };